import React from 'react';
import TradingSideBadge from '../../components/TradingSideBadge';
import { formatCurrency, formatDateTime, isSet } from '../../helpers';
import PositionStatusBadge from '../../components/PositionStatusBadge';
import PlatformBadge from '../../components/PlatformBadge';
import { IPosition } from './position';
import { useHistory } from 'react-router-dom';
import { tradePnL } from '../../helpers/positionHelpers';

interface IProps {
  position: IPosition;
}

const OpenPositionRow: React.FC<IProps> = ({ position }) => {
  const { swap, commission, totalProfitLoss } = position;
  // Every row here is open, so this is the float — via the shared helper so the three P&L
  // surfaces cannot drift.
  const pL = tradePnL(position);
  const history = useHistory();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    if (e.metaKey || e.ctrlKey) {
      window.open(`/positions/${position.id}`, '_blank');
      return;
    }
    history.push(`/positions/${position.id}`);
  };

  return (
    <tr key={position.id} onClick={handleClick}>
      <td>{position.id}</td>
      <td>
        <TradingSideBadge side={position.side} />
      </td>
      <td>{position.symbol}</td>
      <td style={{ minWidth: '80px' }}>{position.accountId}</td>
      <td>
        <PlatformBadge platform={position.platform} />
      </td>
      <td>
        <PositionStatusBadge position={position} />
      </td>
      <td className="text-nowrap">{formatDateTime(position.openedAt)}</td>
      <td>{position.size}</td>
      <td style={{ minWidth: '150px' }} className="text-nowrap">
        {isSet(pL) ? formatCurrency(pL) : '-'}
      </td>
      <td>{formatCurrency(swap === null ? 0 : swap)}</td>
      <td>{isSet(commission) ? formatCurrency(commission) : '-'}</td>
      <td style={{ minWidth: '150px' }} className="text-nowrap">
        {isSet(totalProfitLoss) ? formatCurrency(totalProfitLoss) : '-'}
      </td>
    </tr>
  );
};

export default React.memo(OpenPositionRow);
